const { countryShouldAcceptInteger } = require('../utils/constants');

/* eslint-disable no-useless-escape */
const componentCodeBack = (formData) => {
  const unitPriceShouldAcceptInteger = countryShouldAcceptInteger(formData.publicKey);
  const unitPriceValue = unitPriceShouldAcceptInteger ? '75' : '75.56';

  return ([
    {
      code: `
    const preference = new Preference(client);

    preference.create({
      body: {
        items: [
          {
            title: 'My product',
            quantity: 1,
            unit_price: 2000  // ${unitPriceShouldAcceptInteger ? 'item unit price' : 'item unit price, must be an integer'}
          }
        ],
        // Allow only logged payments. To allow guest payments you can delete omit this property
        purpose: 'wallet_purchase'
      }
    })
    .then(console.log)
    .catch(console.log);
    `,
      type: 'javascript',
      extension: 'js',
      value: 'node',
      name: 'Node.js',
    },
    {
      code: `
    <?php
      use MercadoPago\\MercadoPagoConfig;
      MercadoPagoConfig::setAccessToken("PROD_ACCESS_TOKEN");

      $client = new PreferenceClient();
      $preference = $client->create([
        "items"=> array(
          array(
            "title" => "My product",
            "quantity" => 1,
            "unit_price" => 2000  // ${unitPriceShouldAcceptInteger ? 'item unit price' : 'item unit price, must be an integer'}
          )
        ),
        // Allow only logged payments. To allow guest payments you can delete omit this property
        "purpose" => "wallet_purchase"
      ]);
    ?>
    `,
      type: 'php',
      extension: 'php',
      value: 'php',
      name: 'PHP',
    },
    {
      code: `
    // Mercado Pago SDK
    import com.mercadopago.MercadoPagoConfig;
    // Add Your credentials
    MercadoPagoConfig.setAccessToken("PROD_ACCESS_TOKEN");

    // Create a preference object
    PreferenceClient client = new PreferenceClient();

    // Create an item in the preference
    List<PreferenceItemRequest> items = new ArrayList<>();
    PreferenceItemRequest item =
      PreferenceItemRequest.builder()
          .title("My product")
          .quantity(1)
          .unitPrice(new BigDecimal("100"))  // ${unitPriceShouldAcceptInteger ? 'item unit price' : 'item unit price, must be an integer'}
          .build();
    items.add(item);

    PreferenceRequest request = PreferenceRequest.builder()
      // o .purpose('wallet_purchase') only allows logged payments
      // to allow guest payments you can omit this line
      .purpose('wallet_purchase')
      .items(items).build();

    client.create(request);
    `,
      type: 'java',
      extension: 'java',
      value: 'java',
      name: 'Java',
    },
    {
      code: `
    # Mercado Pago SDK
    require 'mercadopago'
    # Add Your credentials
    sdk = Mercadopago::SDK.new('PROD_ACCESS_TOKEN')

    # Create a preference object
    preference_data = {
      # the purpose: 'wallet_purchase', allows only logged payments
      # to allow guest payments you can omit this property
      purpose: 'wallet_purchase',
      items: [
        {
          title: 'My product',
          unit_price: ${unitPriceValue},  // ${unitPriceShouldAcceptInteger ? 'item unit price' : 'item unit price, must be an integer'}
          quantity: 1
        }
      ]
    }
    preference_response = sdk.preference.create(preference_data)
    preference = preference_response[:response]

    # This value is the preferenceId you will use in the HTML on Brick startup
    @preference_id = preference['id']
    `,
      type: 'ruby',
      extension: 'rb',
      value: 'ruby',
      name: 'Ruby',
    },
    {
      code: `
    // Mercado Pago SDK
    using MercadoPago.Config;
    // Add Your credentials
    MercadoPagoConfig.AccessToken = "PROD_ACCESS_TOKEN";
    // Create the preference request object
    var request = new PreferenceRequest
    {
      // the Purpose = 'wallet_purchase', allows only logged payments.
      // to allow guest payments you can omit this property
        Purpose = 'wallet_purchase',
        Items = new List<PreferenceItemRequest>
        {
            new PreferenceItemRequest
            {
                Title = "My product",
                Quantity = 1,
                CurrencyId = "BRL",
                UnitPrice = ${unitPriceValue}m,  // ${unitPriceShouldAcceptInteger ? 'item unit price' : 'item unit price, must be an integer'}
            },
        },
    };

    // Create the preference using the client
    var client = new PreferenceClient();
    Preference preference = await client.CreateAsync(request);
    `,
      type: 'csharp',
      extension: 'cs',
      value: 'csharp',
      name: 'C Sharp',
    },
    {
      code: `
    # Mercado Pago SDK
    import mercadopago
    # Add Your credentials
    sdk = mercadopago.SDK("PROD_ACCESS_TOKEN")
    # Create an item in the preference
    preference_data = {
      # the "purpose": "wallet_purchase", allows only logged in payments
      # to allow guest payments, you can omit this property
        "purpose": "wallet_purchase",
        "items": [
            {
                "title": "My Item",
                "quantity": 1,
                "unit_price": ${unitPriceValue}  // ${unitPriceShouldAcceptInteger ? 'item unit price' : 'item unit price, must be an integer'}
            }
        ]
    }

    preference_response = sdk.preference().create(preference_data)
    preference = preference_response["response"]
    `,
      type: 'python',
      extension: 'py',
      value: 'python',
      name: 'Python',
    },
    {
      code: `
    curl -X POST \
    'https://api.mercadopago.com/checkout/preferences' \
    -H 'Content-Type: application/json' \
    -H 'cache-control: no-cache' \
    -H 'Authorization: Bearer **PROD_ACCESS_TOKEN**' \
    -d '{
      "purpose": "wallet_purchase",
      "items": [
          {
              "title": "My product",
              "quantity": 1,
              "unit_price": ${unitPriceValue}  // ${unitPriceShouldAcceptInteger ? 'item unit price' : 'item unit price, must be an integer'}
          }
      ]
    }'
    `,
      type: 'curl',
      extension: 'txt',
      value: 'curl',
      name: 'Curl',
    },
  ]);
};

module.exports = componentCodeBack;
